<script setup>

import { computed } from 'vue';

const logo = computed(() => {
    let template = '';
    switch (true) {
        case /tradescale/.test(location.hostname):
            template = '<span>KEPLER-22</span> <span>Trusted global broker</span>';
            break;
        default:
            //template = '<span>LOGO</span>';
            template = `<span>BULLKERO</span> <span>TRADING PLATFORM</span>`;
            break;
    }

    return template;
});

</script>

<template>
    <div class="cover">
        <div class="logo-container">
            <div class="logo" v-html="logo"/>
        </div>
        <div class="container">
            <slot/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cover {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    //background-color: var(--body-bg, $body-bg);
}

.logo-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.container {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--main-text-color, $main-text-color);
}

.logo {
    line-height: 1;
    white-space: nowrap;

    &:deep(img) {
        width: 200px;
    }

    &:deep(span):first-child {
        color: #1bd72e;
        font-weight: bold;
        letter-spacing: 8px;
    }

    &:deep(span):last-child {
        //margin-left: 8px;
        display: block;
        text-align: right;
    }
}

@media (min-width: 1025px) {
    .logo {
        height: 100px;
        width: 468px;

        &:deep(span):first-child {
            font-size: 5.6rem;
        }

        &:deep(span):last-child {
            font-size: 1.1rem;
            letter-spacing: 20px;
        }
    }

    .container {
        width: 45%;
        height: 100%;
        padding-left: 5vw;
        background: radial-gradient(circle at right, #000000, #000000 70%, var(--secondary, $secondary) 80%, #00000000 30%);
    }
}

@media (max-width: 1024px) {
    .cover {
        flex-direction: column;
        justify-content: space-evenly;
    }

    .logo {
        height: 64px;
        width: 300px;

        &:deep(span):first-child {
            font-size: 3.3rem;
        }

        &:deep(span):last-child {
            font-size: 0.9rem;
            margin-right: 5px;
            letter-spacing: 12px;
        }
    }

    .container {
        padding-top: 140px;
        width: 100%;
        min-height: 70%;
        background: radial-gradient(circle at bottom, #000000, #000000 70%, var(--secondary, $secondary) 80%, #00000000 30%);
    }
}
</style>
